<template>
    <div class="grid-cards">
        <BuildingCardComponent v-for="building in this.buildings.slice(0, 4)" 
            :key=building.buildingTypeId 
            v-bind="building"
            v-model:planetQueue="building.planetQueue" 
        />
    </div>
    <div class="facilities-building-container">
        <h2 class="display-m content-1">Facilities</h2>
        <div class="grid-cards">
            <BuildingCardComponent v-for="building in this.buildings.slice(4)" 
                :key=building.buildingTypeId 
                v-bind="building" 
                v-model:planetQueue="building.planetQueue"
            />
        </div>
    </div>
</template>

<style scoped>
.facilities-building-container{
    padding: 24px 0px;
}

.facilities-building-container h2 {
    padding: 24px 0px;
}

.grid-cards {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
    gap: 24px;
    width: 100%;
}

@media screen and (max-width: 640px) {
    .grid-cards {
        grid-template-columns: repeat(auto-fit, minmax(311px, 1fr));
    }
}
</style>

<script>
import { sprintf } from 'sprintf-js';

import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import * as mercureTopicConstant from '@/constants/mercureTopicConstant';

import BuildingCardComponent from '@/components/BuildingCardComponent.vue'

export default {
    name: 'BuildingsComponent',
    components: {
        BuildingCardComponent
    },
    setup() {
        const userLoginDataStorageInstance = userLoginDataStorage();
        return {
            userLoginDataStorageInstance,
            mercureTopicConstant
        }
    },
    data() {
        return {
            userId: this.userLoginDataStorageInstance.getUserId(),
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId(),
            buildings: [],
            mercureConnection: null,
        }
    },
    mounted() {
        this.getBuildings();
        this.cretateMercureEvent();
    },
    unmounted() {
        this.closeMercureEvent();
    },
    methods: {
        getBuildings() {
            this.$axios.getPlanetBuildings(this.planetId).then(response => {
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.buildings = response.data.buildingDataCollection;
            }).catch(error => {
                console.error("Error buildings request:", error);
            });
        },
        cretateMercureEvent()
        {
            this.mercureEvent = this.$mercure.createMercureEvent(
                sprintf(mercureTopicConstant.USER_BUILDING_VIEW_TOPIC, this.userId)
            );

            this.mercureEvent.onmessage = event => {
                const data = JSON.parse(event.data);
                
                const key = this.buildings.findIndex(obj => obj.buildingTypeId === data.buildingTypeId);
                this.buildings.splice(key, 1, data);
                this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            };
        },
        closeMercureEvent()
        {
            this.mercureEvent.close();
            this.mercureEvent = null;
        }
    }
}
</script>